import {
  ActionDropdown,
  ActionDropdownMenuItem,
} from "../../components/ui/actions/ActionDropdown";
import { Show } from "solid-js";
import useAppointmentSchedule from "../../services/useAppointmentSchedule";
import { Modal } from "../../components/ui/Modal";
import { Icon } from "@iconify-icon/solid";
import { DateInput } from "../../components/ui/form/DateInput";
import { LoadingButton } from "../../components/ui/Button";
import { DialogFooter } from "@/components/shadcn/dialog";


const appointmentActions = (action, actionText, icon, confirm = false) => {
  return {
    title: "Are you sure?",
    message: "Do you really want to " + actionText + " this appointment?",
    url: "/appointment/" + action,
    icon: icon,
    action: action,
    confirm: confirm,
    text: action,
    button: "Confirm",
  };
};

export const onAction = (key) => {
  if (key === "schedule") {
    return appointmentActions(
      "schedule",
      "schedule next appointment for",
      "carbon:prompt-session"
    );
  }

  if (key === "close") {
    return appointmentActions("close", "close", "carbon:prompt-session");
  }

  if (key === "collect-fees") {
    return appointmentActions(
      "collect-fees",
      "collect fees for",
      "carbon:prompt-session"
    );
  }

  if (key === "cancel") {
    return appointmentActions(
      "cancel",
      "cancel",
      "carbon:prompt-session",
      true
    );
  }

  if (key === "refund") {
    return appointmentActions(
      "refund",
      "refund & cancel",
      "carbon:prompt-session"
    );
  }

  if (key === "reschedule") {
    return appointmentActions(
      "reschedule",
      "reschedule",
      "carbon:prompt-session"
    );
  }

  if (key === "to-checkup") {
    return appointmentActions(
      "to-checkup",
      "proceed checkup for",
      "carbon:prompt-session"
    );
  }

  return null;
};

export const AppointmentActionDropdown = (props) => {
  const DropdownAction = (key) => {
    props.onAction(onAction(key), props.key);
  };

  const {
    showRescheduleAppointmentModal,
    showNextAppointmentModal,
    showModal,
    closeModal,
    loading,
    title,
    handleScheduleInput,
    onSaveSchedule,
    scheduleForm,
  } = useAppointmentSchedule({
    key: props.key,
    status: props.status,
  });

  return (
    <>
      <ActionDropdown asIcon={true}>
        <Show
          when={props.status === "Cancelled" || props.status === "Completed"}
        >
          <ActionDropdownMenuItem
            icon="carbon:prompt-session"
            onClick={showNextAppointmentModal}
          >
            Schedule Next Appointment
          </ActionDropdownMenuItem>
        </Show>
        <Show when={props.status === "Current"}>
          <ActionDropdownMenuItem
            icon="carbon:prompt-session"
            onClick={() => {
              DropdownAction("close");
            }}
          >
            Close Appointment
          </ActionDropdownMenuItem>
        </Show>
        <Show when={props.status === "Pending"}>
          <ActionDropdownMenuItem
            icon="carbon:prompt-session"
            onClick={() => {
              DropdownAction("to-checkup");
            }}
          >
            Move to Checkup
          </ActionDropdownMenuItem>
          <ActionDropdownMenuItem
            icon="carbon:prompt-session"
            onClick={() => {
              DropdownAction("collect-fees");
            }}
          >
            Collect Fees
          </ActionDropdownMenuItem>
          <ActionDropdownMenuItem
            icon="carbon:prompt-session"
            onClick={() => {
              DropdownAction("cancel");
            }}
          >
            Cancel Appointment
          </ActionDropdownMenuItem>
          <ActionDropdownMenuItem
            icon="carbon:prompt-session"
            onClick={showRescheduleAppointmentModal}
          >
            Reschedule Appointment
          </ActionDropdownMenuItem>
        </Show>
        <Show when={props.status === "Queue"}>
          <ActionDropdownMenuItem
            icon="carbon:prompt-session"
            onClick={() => {
              DropdownAction("refund");
            }}
          >
            Refund & Cancel Appointment
          </ActionDropdownMenuItem>
          <ActionDropdownMenuItem
            icon="carbon:prompt-session"
            onClick={() => {
              DropdownAction("to-checkup");
            }}
          >
            Move to Checkup
          </ActionDropdownMenuItem>
          <ActionDropdownMenuItem
            icon="carbon:prompt-session"
            onClick={showRescheduleAppointmentModal}
          >
            Reschedule Appointment
          </ActionDropdownMenuItem>
        </Show>
      </ActionDropdown>
      {/* Reschedule Appointment Modal */}
      <Modal
        open={showModal()}
        title={title()}
        onClose={() => closeModal()}
        fetching={loading()}
        hideOnOutsideClick={false}
        error={""}
      >
        <div class="grid gap-4 py-4">
          <div class="col-span-2">
            <DateInput
              label="Date"
              name="date"
              form={scheduleForm}
              input={handleScheduleInput}
            />
          </div>
        </div>
        <DialogFooter>
          <LoadingButton
            loading={loading()}
            onClick={onSaveSchedule}
            class="bg-green-500 hover:bg-green-600"
          >
            <Icon icon="mdi:content-save" class="mr-2" />
            {title()}
          </LoadingButton>
        </DialogFooter>
      </Modal>
    </>
  );
};
